<template>
  <div>
	<div id="fullpage">
    <div class="section page1" >第一页</div>
    <div class="section page2">第二页</div>
    <div class="section">第三页</div>
  </div>
  </div>
</template>
<script>
import 'fullpage.js/dist/fullpage.css';
import fullpage from 'fullpage.js'
export default {
  name: "cooperate",
	// components: {
	// 	fullPage:"fullpage"	
	// },
  data() {
	
    return {
		fullpageEl:null
	};
  },

  mounted() {
	// 初始化fullPage
    this.fullpageEl=new fullpage(this.$el, {
      // fullPage.js的选项
      navigation: true, // 导航
      // 更多选项...
    });
  },
  destroyed () {
	this.fullpageEl=null;  
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
	#fullpage{
		height: 100vh;
	}
</style>
